import { ImageLoader } from "next/image";

const apiImageLoader: ImageLoader = ({ src }) => {
  return src;
};

export default apiImageLoader;
